import React from "react";
import ErrorIcon from "@mui/icons-material/Error";
import "./Dashboard.css";

const UserFormModal = ({
  showForm,
  formType,
  formData,
  errors,
  inputStyle,
  onClose,
  onSubmit,
  onChange,
  countries,
  errorMessage,
  onFileChange
}) => {
  if (!showForm) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h2>{formType === "client" ? "Add Client" : "Add Member"}</h2>
        <form onSubmit={onSubmit}>
          {/* {["firstName", "lastName", "phoneNumber", "email", ...(formType === "client" ? ["companyName"] : [])].map((field) => (
            <div key={field}>
              <input
                style={inputStyle}
                type={field === "email" ? "email" : "text"}
                placeholder={field.replace(/^\w/, (c) => c.toUpperCase())}
                name={field}
                value={formData[field] || ""}
                onChange={onChange}
                className={errors[field] ? "error-input" : ""}
              />
              {errors[field] && (
                <p className="error" style={{ marginTop: "10px" }}>
                  {errors[field]}
                </p>
              )}
            </div>
          ))} */}
          {["firstName", "lastName", "phoneNumber", "email", ...(formType === "client" ? ["companyName"] : [])].map((field) => (
            <div key={field}>
              {field === "phoneNumber" ? (
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <select
                    value={formData.countryCode || '+962'}
                    onChange={(e) => onChange({ target: { name: 'countryCode', value: e.target.value } })}
                    style={{
                      ...inputStyle,
                      width: '120px',
                      paddingRight: '5px',
                      borderRight: 'none',
                      borderTopRightRadius: 0,
                      marginTop: '8px',
                      color:'#bcb7b7',
                      borderBottomRightRadius: 0,
                      background: '#f5f3f066'
                    }}
                  >
          
                    {countries.map((country, index) => (
                      <option  key={`${country.code}-${index}`} value={country.code}>
                        {country.name} {country.code}
                      </option>
                    ))}
                  </select>
                  <input
                    style={{
                      ...inputStyle,
                      flex: 1,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      paddingLeft: '10px'
                    }}
                    type="text"
                    placeholder="Phone Number"
                    name={field}
                    value={formData[field] || ""}
                    onChange={onChange}
                    className={errors[field] ? "error-input" : ""}
                  />
                </div>

              ) : (
                <input
                  style={inputStyle}
                  type={field === "email" ? "email" : "text"}
                  placeholder={field.replace(/^\w/, (c) => c.toUpperCase())}
                  name={field}
                  value={formData[field] || ""}
                  onChange={onChange}
                  className={errors[field] ? "error-input" : ""}
                />
              )}
              {errors[field] && (
                <p className="error"  style={{ marginTop: "10px" , padding:'0px 5px' }}>
                  {errors[field]}
                </p>
              )}
            </div>
          ))}
          {/* {countries} */}
          {/* {countries?.map((ele)=>{
            return(
              <>
              <p>{ele.code}</p>
              </>
            )
          })} */}

          <div className="upload-container" style={{
            border: '2px dashed #e0e0e0',
            borderRadius: '8px',
            padding: '10px',
            marginTop: '5px',
            textAlign: 'center',
            backgroundColor: '#fafafa',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            ...(errors.imageId && { borderColor: '#ff4444', backgroundColor: '#fff5f5' })
          }}>
            <input
              style={{ display: 'none' }}
              type="file"
              accept="image/*"
              onChange={onFileChange}
              id="image-upload"
            />
            <label
              htmlFor="image-upload"
              style={{
                cursor: 'pointer',
                display: 'block',
                width: '100%',
                height: '100%'
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#666">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21,15 16,10 5,21" />
                </svg>
                <div>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: '#333' }}>
                    Click to upload image
                  </p>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#666' }}>
                    or drag and drop
                  </p>
                </div>
              </div>
            </label>
          </div>
          {errors.imageId && (
            <p className="error" style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <ErrorIcon style={{ fontSize: "16px" }} /> {errors.imageId}
            </p>
          )}

          <p style={{ color: "red", fontWeight: '400', fontSize: '14px' }}>  {errorMessage ? errorMessage : ''}</p>

          <div className="dialog-actions">
            <button type="button" onClick={onClose} className="btn cancel">Cancel</button>
            <button type="submit" className="btn send">Add</button>
          </div>
        </form>

      </div>

    </div>
  );
};

export default UserFormModal;
